export default __webpack_public_path__ + "static/media/client-23.cc3f5e86.png";